/**
  DO NOT EDIT THIS FILE MANUALLY
  Generated by `Opus::Mkt::Tools::GenerateReactData`
  If this file is out-of-sync or causing builds to fail, try running `scripts/bin/remote-script ./mkt/Tools/generate_react_data.rb`
*/

declare global {
  interface SailIntlLocale {
    'en-US': true;
    'es-419': true;
    'zh-Hans': true;
    'de-DE': true;
    'en-GB': true;
    'nl-NL': true;
    'fr-FR': true;
    'pt-BR': true;
    'fr-CA': true;
    'it-IT': true;
    'es-ES': true;
    'sv-SE': true;
    'ja-JP': true;
    'th-TH': true;
  }
}

export type LocaleData = {
  code: string;
  bcp47: keyof SailIntlLocale;
  iso6391: string;
  localizedName: string;
};

/* eslint-disable prettier/prettier */
export const Locales = {
  enUs: {code: 'en', bcp47: 'en-US', iso6391: 'en', localizedName: 'English'},
  es419: {code: 'es-419', bcp47: 'es-419', iso6391: 'es', localizedName: 'Español'},
  zhHans: {code: 'zh-CN', bcp47: 'zh-Hans', iso6391: 'zh', localizedName: '简体中文'},
  deDe: {code: 'de', bcp47: 'de-DE', iso6391: 'de', localizedName: 'Deutsch'},
  enGb: {code: 'en-GB', bcp47: 'en-GB', iso6391: 'en', localizedName: 'English'},
  nlNl: {code: 'nl', bcp47: 'nl-NL', iso6391: 'nl', localizedName: 'Nederlands'},
  frFr: {code: 'fr', bcp47: 'fr-FR', iso6391: 'fr', localizedName: 'Français'},
  ptBr: {code: 'pt-BR', bcp47: 'pt-BR', iso6391: 'pt', localizedName: 'Português'},
  frCa: {code: 'fr-CA', bcp47: 'fr-CA', iso6391: 'fr', localizedName: 'Français'},
  itIt: {code: 'it', bcp47: 'it-IT', iso6391: 'it', localizedName: 'Italiano'},
  esEs: {code: 'es', bcp47: 'es-ES', iso6391: 'es', localizedName: 'Español'},
  svSe: {code: 'sv', bcp47: 'sv-SE', iso6391: 'sv', localizedName: 'Svenska'},
  jaJp: {code: 'ja', bcp47: 'ja-JP', iso6391: 'ja', localizedName: '日本語'},
  thTh: {code: 'th', bcp47: 'th-TH', iso6391: 'th', localizedName: 'ไทย'},
} as const;
/* eslint-enable prettier/prettier */
